import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography } from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteDialog: React.FC<Props> = ({ open, onClose, onConfirm }) => {
  const [text, setText] = useState('');
  const canDelete = text.trim().toUpperCase() === 'DELETE';
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Delete Tenant</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography>Type DELETE to confirm permanent removal.</Typography>
        <TextField value={text} onChange={e => setText(e.target.value)} label="Type DELETE" autoFocus />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="error" disabled={!canDelete} onClick={() => { onConfirm(); setText(''); }}>Delete</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog; 